import { render, staticRenderFns } from "./PopularArtists.vue?vue&type=template&id=d390216e&scoped=true&"
import script from "./PopularArtists.vue?vue&type=script&lang=js&"
export * from "./PopularArtists.vue?vue&type=script&lang=js&"
import style0 from "./PopularArtists.vue?vue&type=style&index=0&id=d390216e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d390216e",
  null
  
)

export default component.exports